export default function init(markup) {
  return { __html: markup };
}



// WEBPACK FOOTER //
// ./src/util/rawMarkup.js